import * as React from 'react';
import LocalDiv from '../localization/LocalDiv';
import Spacer from '../layout/Spacer';
import { SerializedStyles } from '@emotion/core';
import { COLORS } from '../globalStyle/colors';
import FilterIcon from '../icons/FilterIcon';
import { btnStyle } from '../forms/styles/button';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';


type Props = {
  className?: string;

  contentStyle?: SerializedStyles;
  iconStyle?: SerializedStyles;

  useDarkIconColor?: boolean;
  useDisabledIconColor?: boolean;

  onClickFilterIcon?: () => void;
};


/**
 * FilterBar: a convenience component that renders a styled bar with a filter icon and optional child elements.
 *
 * Used to simplify UI setup for e.g. `ReportRecipientTable`.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const FilterBar: React.FC<Props> = props => {
  const fillColor = props.useDisabledIconColor
                    ? COLORS.DARK_GREY
                    : props.useDarkIconColor
                      ? COLORS.DARK_BLUE
                      : COLORS.BLUE

  const filterLabel = useMsgText(Str.Filter);

  return (
  <LocalDiv className={props.className}>
    <button css={btnStyle.invisible} onClick={props.onClickFilterIcon} aria-label={filterLabel}>
      <FilterIcon sizePx={24} fill={fillColor} css={props.iconStyle}/>
    </button>
    <Spacer sizePx={24} />
    <LocalDiv css={props.contentStyle}>
      {props.children}
    </LocalDiv>
  </LocalDiv>
)
};

export default FilterBar;
